import { BusinessProfile } from "../../components/BusinessProfile";

export default function DefaultPage() {
  return <BusinessProfile></BusinessProfile>;
}
